import { useDispatch } from "../store";
import { isPlatform } from "./platform";
import { pushNotification} from '@te/volt-store/lib/actions';

function parseUserAgent(ua: any) {
    const deviceTypes = {
        'mobile': /Mobile|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i,
        'tablet': /Tablet|iPad/i,
        'desktop': /Windows|Macintosh|Linux|X11/i,
        'tv': /Tizen|Web0S|SmartTV|NetCast/i
    };

    const osTypes = {
        'Windows': /Windows NT (\d+\.\d+)/,
        'Mac': /Mac OS X (\d+[\._]\d+)/,
        'Android': /Android (\d+\.\d+)/,
        'WebOS': /Web0S\/(\d+\.\d+)|Web0S|SmartTV|NetCast/,
        'Tizen': /Tizen (\d+\.\d+)/,
        'Linux': /Linux/,
        'iOS': /iPhone|iPad|iPod.*OS (\d+[\._]\d+)/,
    };

    const browsers = [
        { name: 'Edge', regex: /Edg\/(\d+\.\d+)/ },
        { name: 'Chrome', regex: /Chrome\/(\d+\.\d+)/ },
        { name: 'Firefox', regex: /Firefox\/(\d+\.\d+)/ },
        { name: 'Safari', regex: /Version\/(\d+\.\d+).*Safari/ },
        { name: 'Opera', regex: /OPR\/(\d+\.\d+)/ },
        { name: 'Mozilla', regex: /Mozilla\/(\d+\.\d+)/ }
    ];

    const engines = {
        'Blink': /Chrome\/|Chromium\/|Edg\//,
        'WebKit': /AppleWebKit/,
        'Gecko': /Gecko\/|Firefox\//,
        'Presto': /Opera|OPR\//
    };

    const manufacturers = {
        'Samsung': /Samsung|SM-|Tizen/i,
        'LG': /LG|NetCast|Web0S/i,
        'Sony': /Sony|BRAVIA/i,
        'Apple': /iPhone|iPad|iPod|Macintosh/i,
        'Google': /Pixel/i,
        'Huawei': /Huawei/i,
        'Xiaomi': /Xiaomi|Mi/i,
        'OnePlus': /OnePlus/i,
        'Motorola': /Moto/i,
        'Nokia': /Nokia/i,
        'Vizio': /Vizio/i
    };

    let deviceName = "Unknown";
    let version = "Unknown";
    let os = "Unknown";
    let osVersion
    let deviceType = "Unknown";
    let engine = "Unknown";
    let engineVersion = "";
    let manufacturer = "Unknown";

    // Detect OS
    for (const [key, regex] of Object.entries(osTypes)) {
        const match = ua.match(regex);
        if (match) {
            os = key;
            osVersion = match[1] ? match[1].replace('_', '.') : undefined;
            break;
        }
    }

    // Detect device type
    for (const [type, regex] of Object.entries(deviceTypes)) {
        if (regex.test(ua)) {
            deviceType = type;
            break;
        }
    }

    // Detect browser
    for (const browser of browsers) {
        const match = ua.match(browser.regex);
        if (match) {
            deviceName = browser.name;
            version = match[1];
            break;
        }
    }

    // Detect engine
    for (const [name, regex] of Object.entries(engines)) {
        if (regex.test(ua)) {
            engine = name;
            const match = ua.match(new RegExp(`${name}/(\\d+\\.\\d+)`));
            if (match) {
                engineVersion = match[1];
            }
            break;
        }
    }

    // Detect manufacturer
    for (const [name, regex] of Object.entries(manufacturers)) {
        if (regex.test(ua)) {
            manufacturer = name;
            break;
        }
    }

    return {
        client: {
            type: deviceName ? 'browser' : 'unknown',
            name: deviceName,
            version: version,
            engine: engine,
            engineVersion: engineVersion
        },
        os: {
            name: os,
            version: osVersion ?? localStorage.getItem('deviceOSVersion'),
            platform: ""
        },
        device: {
            type: deviceType,
            brand: manufacturer,
            model: ""
        }
    };
}

export const getDeviceInfo = () => {
    const userAgent = navigator.userAgent
    const deviceInfo = parseUserAgent(userAgent)

    return deviceInfo
}

export const checkAndNotifyUnsupportedBrowser = () => {
    const dispatch = useDispatch();
    if (isPlatform('laptop')) {
        const userAgent = navigator.userAgent;
        const vendor = navigator.vendor || '';
        const isBrave = (navigator as any).brave?.isBrave || /Brave/i.test(userAgent);
        const isOpera = /OPR/.test(userAgent) || /Opera/.test(userAgent);
        const isEdge = /Edg/.test(userAgent);
        const isFirefox = /Firefox/.test(userAgent);
        const isSafari = /Safari/.test(userAgent) && !/Chrome/.test(userAgent) && vendor === 'Apple Computer, Inc.';
        const isChrome = !isBrave && !isOpera && !isEdge && /Chrome/.test(userAgent) && vendor === 'Google Inc.';
        const isRecommendedBrowser = isChrome || isFirefox || isSafari;

        // Display toast if it's not a recommended browser
        if (!isRecommendedBrowser) {
            dispatch(
                pushNotification({
                    message: {
                        tag: "unsupportedBrowserDetected",
                        type: "information",
                    },
                })
            );
        }
    }
};
